import React, { useState, useEffect } from "react";
import DentalChart from "../../DentalChart";
import "../../../style/casedetails.css";
import "../../../style/casedetailnew.css";
//import { ToothDatacd } from "../Interfaces/ToothDatacd";
import { DropdownOption } from "../../../Interfaces/DropDownOption";
import { toast } from "react-toastify";
import PatientDetails from "./PatientDetails";
import PlaceOrder from "./PlaceOrder";
import NewFileUpload from "./NewFileUpload";
import SlotSchedule from "./SlotSchedule";
import {
  getTodayYMD,
  isTimePassedToday,
  type DynamicSchedule,
} from "../../../utils/slotBooking";
import { OrderDraft, ToothData, Patient } from "../interface/IPatientDetails";
import { ExistingFile } from "../../ModelViewer";
import { useNavigate } from "react-router-dom";
import { usePrompt } from "../../../hooks/usePrompt";
import { apiAxios } from "../../../utils/apiAxios";


interface CaseDetailsProps {
  data: ToothData[];
  patient?: Patient;
  files?: any[];   // ⭐ add this
  priceSummary?: {
    singleTotal: number;
    bridgeTotal: number;
    grandTotal: number;
  };
  draftId?: string | undefined;
  draftSlot?: { date: string; time: string } | null;

  onChange: (data: ToothData[]) => void;
  onBack: () => void;
  showTabs?: boolean;
}

const API_BASE = process.env.REACT_APP_API_BASE_URL!;
const SHOW_LEGACY_SERVICE_RADIOS = false;
const SHOW_SERVICE_TABS = false; // service type ab "Create new order" popup se chuna jaata hai
const REACT_APP_API_PATH_URL = process.env.REACT_APP_API_PATH_URL!;
const CaseDetails: React.FC<CaseDetailsProps> = ({
  data,
  patient,
  priceSummary: initialPrice,
  draftId,
  draftSlot,
  files = [],
  onChange,
  onBack
}) => {
  const [hasChanges, setHasChanges] = useState(false);

  type ServiceType = "full" | "design" | "slot";
  const [serviceType, setServiceType] = useState<ServiceType>("full");
const [schedule, setSchedule] = useState<DynamicSchedule | null>(null);
const [loadingSchedule, setLoadingSchedule] = useState(false);
  const [activeStep, setActiveStep] = useState(1);
  const [orderDraft, setOrderDraft] = useState<OrderDraft | null>(null);
  const [isSavingDraft, setIsSavingDraft] = useState(false);
  //const [selectedPatient, setSelectedPatient] = useState<Patient | null>(null);
  const [scans, setScans] = useState<(File | ExistingFile)[]>([]);
  // Slot Booking: Date & Time -> Crown(s) -> Patient Details -> Payment (no Scans step)
  const steps = serviceType === "design"
    ? ["Crown(s)", "Scans", "Payment"]
    : serviceType === "slot"
      ? ["Schedule", "Treatment", "Patient", "Payment"]
      : ["Crown(s)", "Patient Details", "Scans", "Payment"];
  const [selectedTeeth, setSelectedTeeth] = useState<ToothData[]>(data || []);
  const [selectedPatient, setSelectedPatient] = useState<Patient | null>(patient || null);
  const [isSavingDraftTop, setIsSavingDraftTop] = useState(false);
  const [isSavingDraftPopup, setIsSavingDraftPopup] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [attachmentFiles, setAttachmentFiles] = useState<File[]>([]);
  const [notes, setNotes] = useState("");
  const [slotDate, setSlotDate] = useState<string>(sessionStorage.getItem("slotDate") || "");
  const [slotTime, setSlotTime] = useState<string>(sessionStorage.getItem("slotTime") || "");

  const { blocker } = usePrompt(hasChanges && !isExiting, () => {
    setShowExitConfirm(true);
  });

  const [priceSummary, setPriceSummary] = useState(
    initialPrice || {
      singleTotal: 0,
      bridgeTotal: 0,
      grandTotal: 0
    }
  );

  const [lastClickedTooth, setLastClickedTooth] = useState<number | null>(null);
  const [materials, setMaterials] = useState<DropdownOption[]>([]);
  const [shades, setShades] = useState<DropdownOption[]>([]);
  // const [selectedTeeth, setSelectedTeeth] = useState<ToothData[]>(data || []);
  const [showPatientDetails, setShowPatientDetails] = useState(false);
  // const [priceSummary, setPriceSummary] = useState({
  //   singleTotal: 0,
  //   bridgeTotal: 0,
  //   grandTotal: 0,
  // });

  // ----------------------------- Fetch Materials and Shades -----------------------------
  const dentalOrder = [
    18, 17, 16, 15, 14, 13, 12, 11,
    21, 22, 23, 24, 25, 26, 27, 28,
    48, 47, 46, 45, 44, 43, 42, 41,
    31, 32, 33, 34, 35, 36, 37, 38
  ];
  const areAdjacentFDI = (a: number, b: number) => {
    const sameQuadrant = Math.floor(a / 10) === Math.floor(b / 10);

    // Normal adjacency inside quadrant
    if (sameQuadrant && Math.abs(a - b) === 1) return true;

    // Midline adjacency
    if (
      (a === 11 && b === 21) ||
      (a === 21 && b === 11) ||
      (a === 41 && b === 31) ||
      (a === 31 && b === 41)
    )
      return true;

    return false;
  };
  const handleRemoveTooth = (toothNumber: number) => {
    setSelectedTeeth(prev => {
      // Remove tooth
      let updated = prev.filter(t => t.toothNumber !== toothNumber);

      // STEP 1: find all bridge groups
      const bridges: Record<number, number[]> = {};

      updated.forEach(t => {
        if (t.bridgeGroupId) {
          if (!bridges[t.bridgeGroupId]) bridges[t.bridgeGroupId] = [];
          bridges[t.bridgeGroupId].push(t.toothNumber);
        }
      });

      // STEP 2: reset all bridges
      updated = updated.map(t => ({
        ...t,
        hasBridge: false,
        bridgeGroupId: null,
      }));

      // STEP 3: rebuild bridges ONLY for adjacent teeth
      let nextBridgeId = 1;

      Object.values(bridges).forEach(group => {
        const sorted = group.sort((a, b) => a - b);

        let temp: number[] = [];

        for (let i = 0; i < sorted.length; i++) {
          if (
            i === 0 ||
            areAdjacentFDI(sorted[i - 1], sorted[i])
          ) {
            temp.push(sorted[i]);
          } else {
            if (temp.length > 1) {
              assignBridge(temp, nextBridgeId++);
            }
            temp = [sorted[i]];
          }
        }

        if (temp.length > 1) {
          assignBridge(temp, nextBridgeId++);
        }
      });

      function assignBridge(teeth: number[], id: number) {
        updated = updated.map(t =>
          teeth.includes(t.toothNumber)
            ? { ...t, hasBridge: true, bridgeGroupId: id }
            : t
        );
      }

      return updated;
    });
  };

  
useEffect(() => {
  const fetchScheduleMaster = async () => {
    try {
      setLoadingSchedule(true);

      const response = await apiAxios.get(
        `${API_BASE}/ScheduleMaster/GetAll`
      );

      const rows = response.data?.singleData ??
                   response.data?.SingleData ??
                   [];

      const activeSchedules: DynamicSchedule[] = rows
        .filter((item: any) => item.isActive ?? item.IsActive)
        .map((item: any) => ({
          scheduleID: item.scheduleID ?? item.ScheduleID,
          scheduleName: item.scheduleName ?? item.ScheduleName,
          durationMinutes:
            item.durationMinutes ?? item.DurationMinutes,
          slotIntervalMinutes:
            item.slotIntervalMinutes ?? item.SlotIntervalMinutes,
          startTime: String(
            item.startTime ?? item.StartTime
          ).substring(0, 5),
          endTime: String(
            item.endTime ?? item.EndTime
          ).substring(0, 5),
          maxCapacity: item.maxCapacity ?? item.MaxCapacity,
          isActive: item.isActive ?? item.IsActive,
        }));

      if (activeSchedules.length === 0) {
        setSchedule(null);
        toast.info("No active schedule is configured.");
        return;
      }

      // Select the first active schedule for now.
      setSchedule(activeSchedules[0]);
    } catch (error) {
      console.error("Failed to load Schedule Master:", error);
      setSchedule(null);
      toast.error("Failed to load schedule settings.");
    } finally {
      setLoadingSchedule(false);
    }
  };

  fetchScheduleMaster();
}, []);

  useEffect(() => {
    const savedServiceType = sessionStorage.getItem("serviceType") as ServiceType | null;
    if (savedServiceType === "full" || savedServiceType === "design" || savedServiceType === "slot") {
      setServiceType(savedServiceType);
    }
  }, []);

  useEffect(() => {
    const savedNotes = sessionStorage.getItem("caseNotes");

    if (savedNotes) {
      setNotes(savedNotes);
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem("caseNotes", notes);
  }, [notes]);
  useEffect(() => {
    if (data && data.length > 0) {
      setSelectedTeeth(data);
    }

    if (patient) {
      setSelectedPatient(patient);
    }

    if (initialPrice) {
      setPriceSummary(initialPrice);
    }
  }, [data, patient, initialPrice]);
  useEffect(() => {
    if (files && files.length > 0) {
      if (draftId) {
        const formattedFiles: ExistingFile[] = files.map((f: any) => ({
          id: f.draftFileId,
          name: f.fileName,
          url: `${REACT_APP_API_PATH_URL}/DentistDrafts/${f.filePath}`,
          size: f.fileSize
        }));

        setScans(formattedFiles);
      }
    }
  }, [files]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [matRes, shadeRes] = await Promise.all([
          apiAxios.get(`${API_BASE}/Material/GetAll`),
          apiAxios.get(`${API_BASE}/Shade/GetAll`)
        ]);

        const matJson = matRes.data;
        const shadeJson = shadeRes.data;

        setMaterials(
          (matJson.singleData || []).map((m: any) => ({
            id: m.materialID,
            name: m.materialName,
            price: m.price,
            duration: m.duration,
            unit: m.unit,
            orderTypeName: m.orderTypeName,
            orderTypeID: m.orderTypeID
          }))
        );

        setShades(
          (shadeJson.singleData || []).map((s: any) => ({
            id: s.shadeID,
            name: s.name
          }))
        );
      } catch (err) {
        console.error("Failed to load data:", err);
      }
    };

    fetchData();
  }, []);

  const getBridgePrimaryTooth = (bridgeGroupId: number) => {
    const bridgeTeeth = selectedTeeth
      .filter(t => t.bridgeGroupId === bridgeGroupId)
      .map(t => t.toothNumber);

    return Math.min(...bridgeTeeth);
  };



  // ----------------------------- Tooth Click -----------------------------
  const handleToothClick = (toothNumber: number, event?: React.MouseEvent) => {
    setSelectedTeeth((prev) => {
      let updated = [...prev];
      const exists = prev.find((t) => t.toothNumber === toothNumber);

      if (event?.shiftKey && lastClickedTooth) {
        const start = Math.min(lastClickedTooth, toothNumber);
        const end = Math.max(lastClickedTooth, toothNumber);
        const range = Array.from({ length: end - start + 1 }, (_, i) => start + i);
        range.forEach((num) => {
          if (!updated.find((t) => t.toothNumber === num)) {
            updated.push({
              toothNumber: num,
              materialId: null,
              shadeId: null,
              hasBridge: false,
            });
          }
        });
        return updated;
      }

      if (exists) {
        return updated.filter((t) => t.toothNumber !== toothNumber);
      } else {
        updated.push({
          toothNumber,
          materialId: null,
          shadeId: null,
          hasBridge: false,
        });
        return updated;
      }
    });

    setLastClickedTooth(toothNumber);
  };
  // const validateStep = (step: number) => {

  //   // STEP 1 VALIDATION
  //   if (step === 1) {
  //     if (selectedTeeth.length === 0) {
  //       toast.info("Please select at least one tooth!");
  //       return false;
  //     }

  //     const missing = selectedTeeth.filter(t => !t.materialId || !t.shadeId);

  //     if (missing.length > 0) {
  //       toast.info("Please select material & shade for all teeth.");
  //       return false;
  //     }
  //   }

  //   if (serviceType === "full") {
  //     // Full Service: step 2 = Patient Details
  //     if (step === 2) {
  //       if (!selectedPatient) {
  //         toast.info("Please select patient.");
  //         return false;
  //       }
  //     }
  //     // step 3 = Scans
  //     if (step === 3) {
  //       if (scans.length === 0) {
  //         toast.info("Please upload scan files.");
  //         return false;
  //       }
  //     }
  //   } else {
  //     // Design Service: step 2 = Scans (no Patient Details)
  //     if (step === 2) {
  //       if (scans.length === 0) {
  //         toast.info("Please upload scan files.");
  //         return false;
  //       }
  //     }
  //   }

  //   return true;
  // };


  // Draft se Slot Booking restore (date, time, service type)
  useEffect(() => {
    if (!draftSlot) return;
    setServiceType("slot");
    sessionStorage.setItem("serviceType", "slot");
    setSlotDate(draftSlot.date);
    setSlotTime(draftSlot.time);
  }, [draftSlot]);

  useEffect(() => {
    sessionStorage.setItem("slotDate", slotDate);
    sessionStorage.setItem("slotTime", slotTime);
  }, [slotDate, slotTime]);

  const validateStep = (step: number) => {
    // ✅ SLOT BOOKING: Date & Time -> Crown(s) -> Patient Details
    if (serviceType === "slot") {
      if (step === 1) {
        if (!slotDate) {
          toast.info("Please select a date");
          return false;
        }
        if (!slotTime) {
          toast.info("Please select a time slot");
          return false;
        }
        // purane draft ka expired slot
        if (slotDate < getTodayYMD() || (slotDate === getTodayYMD() && isTimePassedToday(slotTime))) {
          toast.info("Selected slot has passed. Please choose a new date & time.");
          return false;
        }
      }

      if (step === 2) {
        if (selectedTeeth.length === 0) {
          toast.info("Please select at least one tooth!");
          return false;
        }
        const missing = selectedTeeth.filter(t => !t.materialId || !t.shadeId);
        if (missing.length > 0) {
          toast.info("Please select material & shade for all teeth.");
          return false;
        }
      }

      if (step === 3) {
        if (!selectedPatient) {
          toast.info("Please select patient.");
          return false;
        }
      }

      return true;
    }

    // STEP 1 VALIDATION
    if (step === 1) {
      if (selectedTeeth.length === 0) {
        toast.info("Please select at least one tooth!");
        return false;
      }

      // ✅ Only Full Service requires material + shade
      if (serviceType === "full") {
        const missing = selectedTeeth.filter(t => !t.materialId || !t.shadeId);

        if (missing.length > 0) {
          toast.info("Please select material & shade for all teeth.");
          return false;
        }
      }
    }

    if (serviceType === "full") {
      if (step === 2) {
        if (!selectedPatient) {
          toast.info("Please select patient.");
          return false;
        }
      }

      if (step === 3) {
        if (scans.length === 0) {
          toast.info("Please upload scan files.");
          return false;
        }
      }
    } else {
      if (step === 2) {
        if (scans.length === 0) {
          toast.info("Please upload scan files.");
          return false;
        }
      }
    }

    return true;
  };
  const handleContinue = () => {

    if (!validateStep(activeStep)) return;

    if (activeStep < steps.length) {
      setActiveStep(prev => prev + 1);
    }

  };

  // ----------------------------- Material/ Shade Select -----------------------------
  const handleSelectChange = (
    toothNumber: number,
    type: "material" | "shade",
    value: string
  ) => {
    setSelectedTeeth((prev) => {
      const bridgeId = prev.find((t) => t.toothNumber === toothNumber)?.bridgeGroupId;
      const targetGroup = bridgeId
        ? prev.filter((t) => t.bridgeGroupId === bridgeId).map((t) => t.toothNumber)
        : [toothNumber];

      const selectedMaterial =
        type === "material" ? materials.find((m) => m.id === Number(value)) : undefined;

      return prev.map((t) => {
        if (!targetGroup.includes(t.toothNumber)) return t;

        if (type === "material") {
          return {
            ...t,
            materialId: Number(value),
            materialName: selectedMaterial?.name,
            price: selectedMaterial?.price ?? 0, // ✅ assign price to all teeth in bridge
            duration: selectedMaterial?.duration ?? 0,  // <-- save duration
            unit: selectedMaterial?.unit ?? 0,
            orderTypeName: selectedMaterial?.orderTypeName ?? "",          // <-- save unit
            orderTypeID: selectedMaterial?.orderTypeID ? Number(selectedMaterial.orderTypeID) : undefined
          };
        }

        if (type === "shade") {
          return {
            ...t,
            shadeId: Number(value),
            shadeName: shades.find((s) => s.id === Number(value))?.name,
          };
        }

        return t;
      });
    });
  };

  // ----------------------------- Toggle Bridge -----------------------------
  const toggleBridge = (group: number[]) => {
    setSelectedTeeth((prev) => {
      let updated = [...prev];
      const [a, b] = group;

      const toothA = updated.find((t) => t.toothNumber === a);
      const toothB = updated.find((t) => t.toothNumber === b);

      const bridgeA = toothA?.bridgeGroupId || null;
      const bridgeB = toothB?.bridgeGroupId || null;

      // ===============================
      // REMOVE BRIDGE
      // ===============================
      if (bridgeA && bridgeA === bridgeB) {
        return updated.map((t) =>
          t.bridgeGroupId === bridgeA
            ? { ...t, hasBridge: false, bridgeGroupId: null }
            : t
        );
      }

      // ===============================
      // CREATE / MERGE BRIDGE
      // ===============================

      const teethToBridge = new Set<number>([a, b]);

      if (bridgeA) {
        updated
          .filter((t) => t.bridgeGroupId === bridgeA)
          .forEach((t) => teethToBridge.add(t.toothNumber));
      }

      if (bridgeB) {
        updated
          .filter((t) => t.bridgeGroupId === bridgeB)
          .forEach((t) => teethToBridge.add(t.toothNumber));
      }

      // Generate new bridge id
      const allBridgeIds = new Set(
        updated.map((t) => t.bridgeGroupId).filter(Boolean)
      );

      let newBridgeId = 1;
      while (allBridgeIds.has(newBridgeId)) newBridgeId++;

      // 🔥 FIND SOURCE TOOTH (A has priority)
      const sourceTooth =
        toothA?.materialId
          ? toothA
          : toothB?.materialId
            ? toothB
            : null;

      updated = updated.map((t) => {
        if (!teethToBridge.has(t.toothNumber)) return t;

        return {
          ...t,
          hasBridge: true,
          bridgeGroupId: newBridgeId,
          materialId: sourceTooth?.materialId ?? t.materialId,
          materialName: sourceTooth?.materialName ?? t.materialName,
          price: sourceTooth?.price ?? t.price,
          //    duration: sourceTooth?.duration ?? t.duration,
          //   unit: sourceTooth?.unit ?? t.unit,
          orderTypeName: sourceTooth?.orderTypeName ?? t.orderTypeName,
          orderTypeID: sourceTooth?.orderTypeID ?? t.orderTypeID,
          shadeId: sourceTooth?.shadeId ?? t.shadeId,
          shadeName: sourceTooth?.shadeName ?? t.shadeName,
        };
      });

      return updated;
    });
  };


  const isBridged = (a: number, b: number) => {
    const toothA = selectedTeeth.find(t => t.toothNumber === a);
    const toothB = selectedTeeth.find(t => t.toothNumber === b);

    return (
      toothA?.bridgeGroupId &&
      toothB?.bridgeGroupId &&
      toothA.bridgeGroupId === toothB.bridgeGroupId
    );
  };

  // ----------------------------- Price Calculation -----------------------------
  const calculatePrices = () => {

    // ✅ DESIGN SERVICE → flat ₹250 per selected tooth
    if (serviceType === "design") {
      const total = selectedTeeth.length * 250;

      return {
        singleTotal: total,
        bridgeTotal: 0,
        grandTotal: total,
      };
    }

    // ✅ FULL SERVICE → keep existing material / bridge logic
    let singleTotal = 0;
    let bridgeTotal = 0;
    const grouped: Record<number, ToothData[]> = {};

    selectedTeeth.forEach((t) => {
      if (t.bridgeGroupId) {
        if (!grouped[t.bridgeGroupId!]) grouped[t.bridgeGroupId!] = [];
        grouped[t.bridgeGroupId!].push(t);
      }
    });

    // Single teeth
    selectedTeeth.forEach((t) => {
      if (!t.bridgeGroupId && t.price) singleTotal += t.price;
    });

    // Bridge teeth: sum price of all teeth in bridge
    Object.values(grouped).forEach((group) => {
      group.forEach((t) => {
        if (t.price) bridgeTotal += t.price;
      });
    });

    return { singleTotal, bridgeTotal, grandTotal: singleTotal + bridgeTotal };
  };

  useEffect(() => {
    setPriceSummary(calculatePrices());
  }, [selectedTeeth, materials, serviceType]);

  // ----------------------------- Save to Local Storage -----------------------------
  useEffect(() => {
    const orderTypeName =
      selectedTeeth.find(t => t.orderTypeName)?.orderTypeName || "";
    const orderTypeID =
      selectedTeeth.find(t => t.orderTypeID)?.orderTypeID || null;

    const orderData = {
      selectedTeeth,
      priceSummary,
      orderTypeName,
      orderTypeID,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem("orderSummary", JSON.stringify(orderData));
  }, [selectedTeeth, priceSummary]);

  const [showExitConfirm, setShowExitConfirm] = useState(false);

  const saveDraftLogic = async () => {
    const storedClinic = sessionStorage.getItem("selectedClinic");

    if (storedClinic) {
      try {
        const parsedClinic = JSON.parse(storedClinic);
        const formData = new FormData();

        formData.append("DraftId", draftId || "");
        formData.append("ClinicId", parsedClinic.clinicID);
        formData.append("PatientId", selectedPatient?.patientID?.toString() || "");
        formData.append(
          "OrderData",
          JSON.stringify({
            selectedTeeth,
            priceSummary,
            selectedPatient,
            notes,
            serviceType,
            slotDate,
            slotTime
          })
        );
        formData.append("TotalAmount", priceSummary.grandTotal.toString());

        // files
        scans.forEach((file: any) => {
          if (file instanceof File) {
            formData.append("files", file);
          }
        });

        attachmentFiles.forEach((file) => {
          formData.append("attachmentFiles", file);
        });

        await apiAxios.post(
          `${API_BASE}/Dentist/SaveDraftWithFiles`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        toast.success("Draft Saved Successfully!", {
          onClose: () => {
            onBack();
          },
        });

      } catch (error) {
        console.error(error);
        toast.error("Failed to save draft");
      } finally {
        setIsSavingDraft(false);
        setShowExitConfirm(false);
      }
    }
  };

  const handleSaveDraftAndExit = async () => {
    try {
      setIsExiting(true);
      setHasChanges(false);
      setIsSavingDraftPopup(true); // 🔥 ONLY popup loader

      await saveDraftLogic();

      blocker?.proceed();
    } catch (e) {
      console.error(e);
    } finally {
      setIsSavingDraftPopup(false);
      setShowExitConfirm(false);
    }
  };

  const handleExitWithoutSaving = () => {
    // setShowExitConfirm(false);
    setHasChanges(false);
    blocker?.proceed();
    setShowExitConfirm(false);
    onBack();
  };

  useEffect(() => {
    if (blocker?.state === "blocked") {
      setShowExitConfirm(true); // ✅ correct timing
    }
  }, [blocker]);

  const handleCancelExit = () => {
    blocker?.reset(); // ❌ stop navigation
    setShowExitConfirm(false);
    //setPendingNavigation(null); // ⭐ prevents double popup
  };

  const handleApplyToAll = () => {
    if (selectedTeeth.length === 0) {
      toast.info("No teeth selected!");
      return;
    }

    // Find first tooth that has material selected
    const sourceTooth = selectedTeeth.find(t => t.materialId);

    if (!sourceTooth) {
      toast.info("Please select Material & Shade on at least one tooth.");
      return;
    }

    setSelectedTeeth(prev =>
      prev.map(t => ({
        ...t,
        materialId: sourceTooth.materialId ?? null,
        materialName: sourceTooth.materialName,
        price: sourceTooth.price ?? 0,
        // duration: sourceTooth.duration ?? 0,
        // unit: sourceTooth.unit ?? 0,
        orderTypeName: sourceTooth.orderTypeName ?? "",
        orderTypeID: sourceTooth.orderTypeID ?? undefined,
        shadeId: sourceTooth.shadeId ?? null,
        shadeName: sourceTooth.shadeName ?? "",
      }))
    );

    toast.success("Applied to all selected teeth!");
  };



  // ----------------------------- Send Data to Parent -----------------------------
  useEffect(() => {
    onChange(selectedTeeth);
  }, [selectedTeeth]);

  useEffect(() => {
    if (selectedTeeth.length > 0 || scans.length > 0 || selectedPatient) {
      setHasChanges(true);
    } else {
      setHasChanges(false);
    }
  }, [selectedTeeth, scans, selectedPatient]);
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (!hasChanges) return;

      e.preventDefault();
      e.returnValue = ""; // required for Chrome
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasChanges]);


  return (
    <div className="case-details2 ">
      <div className="row">
        <div className="col-md-4 col-lg-3 col-12 back-btndiv-margin-auto">
          <div className="back-btndiv">
            <div className="back-btndiv" 
           
            onClick={() => {
  const isPaymentStep =
    ((serviceType === "full" || serviceType === "slot") && activeStep === 4) ||
    (serviceType === "design" && activeStep === 3);

  if (isPaymentStep) {
    onBack();
    return;
  }

  if (hasChanges) {
    setShowExitConfirm(true);
  } else {
    onBack();
  }
}}
              style={{ cursor: "pointer" }}>
              <div className="back-icon">
                <i className="bi bi-arrow-left-short"></i>
              </div>
              <span className="back-text">Back</span>
            </div>
            {activeStep < (serviceType === "design" ? 3 : 4) && (
              <button
                className="save-draftbtn"
                type="button"
                onClick={async () => {
                  setIsSavingDraftTop(true);
                  await saveDraftLogic();
                  setIsSavingDraftTop(false);
                }}
                disabled={isSavingDraftTop}
              >
                {isSavingDraftTop ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Saving...
                  </>
                ) : (
                  "Save Draft"
                )}
              </button>
            )}
          </div>
        </div>
        <div className="col-md-8 p-3 col-12">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 top-header-wrapper">

  {/* LEFT / STEPPER */}
  <div className="top-stepper d-flex gap-4 stepper-scroll">
    {steps.map((step, index) => {
      const stepNumber = index + 1;
      return (
        <div
          key={stepNumber}
          className={`step-tab ${activeStep === stepNumber ? "active" : ""}`}
          onClick={() => {
            if (stepNumber < activeStep) {
              setActiveStep(stepNumber);
              return;
            }
            if (stepNumber === activeStep + 1) {
              if (validateStep(activeStep)) {
                setActiveStep(stepNumber);
              }
            }
          }}
        >
          {step}
        </div>
      );
    })}
  </div>

  {/* RIGHT / SERVICE TABS (Full / Design / Schedule) */}
  {SHOW_SERVICE_TABS && (
  <div className="service-tabs" role="tablist">
    {([
      { key: "full", label: "Full Service", icon: "bi-box-seam" },
      { key: "design", label: "Design Service", icon: "bi-pencil-square" },
      { key: "slot", label: "Schedule Order", icon: "bi-calendar2-check" },
    ] as { key: ServiceType; label: string; icon: string }[]).map((tab) => (
      <button
        key={tab.key}
        type="button"
        role="tab"
        aria-selected={serviceType === tab.key}
        className={`service-tab ${serviceType === tab.key ? "active" : ""}`}
        disabled={activeStep === 4 && serviceType !== tab.key}
        onClick={() => {
          if (serviceType === tab.key) return;
          setServiceType(tab.key);
          sessionStorage.setItem("serviceType", tab.key);
          setActiveStep(1);
        }}
      >
        <i className={`bi ${tab.icon}`}></i> {tab.label}
      </button>
    ))}
  </div>
  )}

  {/* LEGACY RADIO BUTTONS (kept, replaced by tabs above) */}
  {SHOW_LEGACY_SERVICE_RADIOS && serviceType !== "slot" && (
  <div className="service-type-toggle d-flex gap-3">
    <label className="service-radio-label d-flex align-items-center gap-1">
      <input
        type="radio"
        name="serviceType"
        value="full"
        checked={serviceType === "full"}
        disabled={activeStep === 4}
        onChange={() => {
          setServiceType("full");
          sessionStorage.setItem("serviceType", "full");
          setActiveStep(1);
        }}
      />
      <span>Full Service</span>
    </label>

    <label className="service-radio-label d-flex align-items-center gap-1">
      <input
        type="radio"
        name="serviceType"
        value="design"
        checked={serviceType === "design"}
        disabled={activeStep === 4}
        onChange={() => {
          setServiceType("design");
          sessionStorage.setItem("serviceType", "design");
          setActiveStep(1);
        }}
      />
      <span>Design Service</span>
    </label>
  </div>
  )}
</div>
        </div>
        <div className="tab-content" id="myTabContent">

          {/* ---------------- SLOT BOOKING: DATE & TIME (step 1) ---------------- */}
      
{/* SLOT BOOKING: STEP 1 - SCHEDULE */}
{serviceType === "slot" && activeStep === 1 && (
  loadingSchedule ? (
    <div className="text-center p-4">
      Loading available schedules...
    </div>
  ) : !schedule ? (
    <div className="alert alert-warning">
      No active schedule is available. Please contact the administrator.
    </div>
  ) : (
    <SlotSchedule
      slotDate={slotDate}
      slotTime={slotTime}
      schedule={schedule}
      onDateChange={setSlotDate}
      onTimeChange={setSlotTime}
      onContinue={handleContinue}
    />
  )
)}

          {/* ---------------- HOME TAB CONTENT ---------------- */}
          {((serviceType !== "slot" && activeStep === 1) ||
            (serviceType === "slot" && activeStep === 2)) && (
            <div>

              {/* Your entire code goes here of first tab */}
              <div className="row">
                <div className="col-md-7">
                  <DentalChart
                    selectedTeeth={selectedTeeth}
                    handleToothClick={handleToothClick}
                    toggleBridge={toggleBridge}
                    disabled={false}   // ✅ chart disabled
                  />
                  <div className="bullet-row">
                    <div className="bullet-item">
                      <span className="bullet blue"></span>
                      <span className="bullet-text blue-text">Crown</span>
                    </div>

                    <div className="bullet-item">
                      <span className="bullet orange"></span>
                      <span className="bullet-text orange-text">Bridge</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="details-container">

                    {selectedTeeth.length === 0 && (
                      <div className="no-selection">
                        <p>Please select teeth to create new order</p>
                      </div>
                    )}
                    {selectedTeeth.length > 0 && (
                      <>
                        <ul className="search-listsect-add">
                          <li>
                            <h5 className="add-detail-add-bridge-sect">Add Details</h5>
                          </li>
                          {serviceType !== "design" && (
                            <li>
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={handleApplyToAll}
                              >
                                Apply To All
                              </button>
                            </li>
                          )}
                        </ul>

                        <div className="all-selected-tooth">
                          {[...selectedTeeth]
                            .sort((a, b) =>
                              dentalOrder.indexOf(a.toothNumber) -
                              dentalOrder.indexOf(b.toothNumber)
                            )
                            .map((tooth, index, arr) => {
                              const sortedArr = arr;
                              const nextTooth = sortedArr[index + 1];

                              const canShowBridge =
                                nextTooth &&
                                areAdjacentFDI(tooth.toothNumber, nextTooth.toothNumber);

                              const bridged = nextTooth
                                ? isBridged(tooth.toothNumber, nextTooth.toothNumber)
                                : false;

                              return (
                                <React.Fragment key={tooth.toothNumber}>
                                  {/* TOOTH CARD */}
                                  <div className="tooth-detail-row">
                                    <div className="row align-items-center">
                                      <div className="col-md-12 d-flex justify-content-between align-items-center gap-2">
                                        <strong className="tooth-number">
                                          Tooth {tooth.toothNumber}
                                        </strong>

                                        {serviceType !== "design" && (
                                          <>
                                            <select
                                              value={tooth.materialId ?? ""}
                                              onChange={(e) =>
                                                handleSelectChange(
                                                  tooth.toothNumber,
                                                  "material",
                                                  e.target.value
                                                )
                                              }
                                              className="modern-input form-select"
                                            >
                                              <option value="">Material</option>
                                              {materials.map((m) => (
                                                <option key={m.id} value={m.id}>
                                                  {m.name}
                                                </option>
                                              ))}
                                            </select>

                                            <select
                                              value={tooth.shadeId ?? ""}
                                              onChange={(e) =>
                                                handleSelectChange(
                                                  tooth.toothNumber,
                                                  "shade",
                                                  e.target.value
                                                )
                                              }
                                              className="modern-input form-select"
                                            >
                                              <option value="">Shade</option>
                                              {shades.map((s) => (
                                                <option key={s.id} value={s.id}>
                                                  {s.name}
                                                </option>
                                              ))}
                                            </select>
                                          </>
                                        )}


                                        <span
                                          className="delete-icon"
                                          onClick={() =>
                                            handleRemoveTooth(tooth.toothNumber)
                                          }
                                        >
                                          <i className="bi bi-x-lg"></i>
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  {canShowBridge && (
                                    <div
                                      className={`bridge-wrapper ${bridged ? "active" : ""
                                        }`}
                                    >
                                      <i
                                        className={`bi ${bridged
                                          ? "bi-x remove-bridge-icon"
                                          : "bi-plus create-bridge-icon"
                                          }`}
                                        onClick={() =>
                                          toggleBridge([
                                            tooth.toothNumber,
                                            nextTooth.toothNumber,
                                          ])
                                        }
                                      />
                                      {!bridged && (
                                        <span className="bridge-text">
                                          Add Bridge
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </React.Fragment>
                              );
                            })}
                        </div>

                        <div className="row case-bottom-section">
                          <div className="col-md-12 pt-1">
                            <label className="label pt-2 pb-2">
                              Attach Photos & Notes (Optional)
                            </label>
                            <input
                              type="file"
                              className="form-control"
                              multiple
                              onChange={(e) => {
                                if (e.target.files) {
                                  setAttachmentFiles(Array.from(e.target.files));
                                }
                              }}
                            />

                            {attachmentFiles.length > 0 && (
                              <div className="mt-2">
                                {attachmentFiles.map((file, index) => (
                                  <div key={index}>{file.name}</div>
                                ))}
                              </div>
                            )}

                          </div>
                          <div className="col-md-12 pt-1">
                            <textarea
                              className="form-control custom-textarea"
                              placeholder="Type here..."
                              value={notes}
                              onChange={(e) => setNotes(e.target.value)}
                            ></textarea>
                          </div>

                          <div className="col-md-12 d-flex justify-content-center">
                            {/* <button className="continue-btn2">
                              <div className="clock-icon-image">
                                <img
                                  className="clock-icon"
                                  src="../flaticon/clock-fill.png"
                                />
                                Latest Delivery in 90 minutes
                              </div>
                            </button> */}
                          </div>

                          <div className="col-md-12">
                            <button
                              className="continue-btn"
                              onClick={handleContinue}
                            >
                              Continue
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>



              </div>



            </div>
          )}

          {/* ---------------- PATIENT DETAILS TAB CONTENT (Full Service only) ---------------- */}
          {((activeStep === 2 && serviceType === "full") || (activeStep === 3 && serviceType === "slot")) && (
            <div>
              <PatientDetails
                selectedTeeth={selectedTeeth}
                setSelectedTeeth={setSelectedTeeth}
                setActiveStep={setActiveStep}
                setOrderDraft={setOrderDraft}
                selectedPatient={selectedPatient}
                setSelectedPatient={setSelectedPatient}
              />
            </div>
          )}

          {/* Scans: step 3 (full) OR step 2 (design) */}
          {((activeStep === 3 && serviceType === "full") || (activeStep === 2 && serviceType === "design")) && (
            <div>
              <NewFileUpload scans={scans}
                setScans={setScans}
                setActiveStep={setActiveStep}
              />
            </div>
          )}

          {/* Payment: step 4 (full) OR step 3 (design) */}
          {((activeStep === 4 && (serviceType === "full" || serviceType === "slot")) || (activeStep === 3 && serviceType === "design")) && (
            <div>
              <PlaceOrder
                scanFiles={scans}
                attachmentFiles={attachmentFiles}
                notes={notes}
                orderDraft={orderDraft}
                onHandleBack={onBack}
                DraftId={draftId}
                isDesignService={serviceType === "design"}
                isSlotBooking={serviceType === "slot"}
                slotDate={slotDate}
                slotTime={slotTime}
              />
            </div>
          )}


        </div>

      </div>
      {
        showExitConfirm && activeStep < (serviceType === "design" ? 3 : 4) && (
          <div className="exit-overlay">
            <div className="exit-modal ">
              <h6 className="border-bottom-exit">Exit Order Creation ?</h6>
              <p className="pt-2">You have unsaved changes. What would you like to do?</p>

              <div className="exit-buttons">
                {activeStep < (serviceType === "design" ? 3 : 4) && (
                  <button
                    className="btn btn-primary"
                    onClick={handleSaveDraftAndExit}
                    disabled={isSavingDraftPopup}
                  >
                    {isSavingDraftPopup ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Saving...
                      </>
                    ) : (
                      "Save Draft"
                    )}
                  </button>
                )}

                <button
                  className="btn btn-secondary  mx-2"
                  onClick={handleExitWithoutSaving}
                >
                  Exit Without Saving
                </button>

                <button
                  className="btn btn-secondary-custom "
                  onClick={handleCancelExit}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default CaseDetails;